import {observer} from 'mobx-react-lite'
import React, {useEffect, useState} from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Loader} from '@components/common/base/loader'
import {useStatsTimelineStore} from '../../stats-timeline-store'
import {downloadStatsTimelineXlsx} from '../../utils/utils'
import FileSVG from './file.svg'

const TwFile = tw.div`
  flex
  items-center
  text-obscure-old
  hover:text-input-disabled-old
  active:text-main-old
`

const TwButton = tw.div`
  cursor-pointer
  w-auto
  hover:underline
  text-action-default
  text-14
`

export const Download = observer(() => {
  const [state, store] = useStatsTimelineStore()
  const [isAllowDownload, setAllowDownload] = useState(false)

  useEffect(() => {
    if (store.eventsXLSX && isAllowDownload && !state.isLoadingXLSX) {
      downloadStatsTimelineXlsx(store.eventsXLSX)
      setAllowDownload(false)
    }
  }, [store.eventsXLSX, state.isLoadingXLSX])

  const downloadXLSX = () => {
    store.updateStatsXLSX()
    setAllowDownload(true)
  }

  if (state.isLoadingXLSX) {
    return (
      <div className="mx-12 whitespace-nowrap">
        <Loader size="xsmall" />
      </div>
    )
  }

  return (
    store.events && (
      <div className="mx-12 whitespace-nowrap" onClick={downloadXLSX}>
        <TwFile>
          <FileSVG />
          <TwButton>{Lang.msg.statsTimeline.download}</TwButton>
        </TwFile>
      </div>
    )
  )
})
